<template>
    <div class="super">
        <van-popup v-model="effectPopup" :close-on-click-overlay='false'>
            <div class="bannerImg" @click="onSuper">
                <img :src="superData.pictureUrl + '?x-oss-process=image/resize,m_pad,w_600,h_600/quality,Q_100/format,jpg'" alt="">
            </div>
            <div class="btnClose" @click="onClose">
                <img src="../../../../assets/img/b2b/btn_close_white32@2x.png" alt="">
            </div>
        </van-popup>
    </div>
</template>
<script>
// 首页弹出广告
import { mapActions } from 'vuex'
export default {
    name: 'super',
    data () {
        return {
            userInfo: '',
            superData: '',
            effectPopup: false
        }
    },
    methods: {
        ...mapActions(['getSuperData']),
        onClose () {
            this.effectPopup = false
        },
        onSuper () {
            this.$router.push({ path: this.superData.link })
        },
        getSuper () {
            this.getSuperData({
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.superData = data
                let updateTime = new Date(data.updateTime.replace(/-/g, '/')).getTime()
                if (!localStorage.getItem('updateTime')) {
                    localStorage.setItem('updateTime', updateTime)
                    this.effectPopup = true
                } else {
                    let updateTime2 = parseInt(localStorage.getItem('updateTime'))
                    if (updateTime2 !== updateTime) {
                        localStorage.setItem('updateTime', updateTime)
                        this.effectPopup = true
                    }
                }
            })
        }
    },
    async mounted () {
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
        if (this.userInfo.belongMerchantCode) {
            if (!this.$route.query.type) {
                this.getSuper()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .super{
        .bannerImg {
            width: 590px;
            height: 590px;
            border-radius: 16px;
            img {
                border-radius: 16px;
                width: 100%;
                height: 100%;
            }
        }
        .btnClose {
            position: fixed;
            width: 64px;
            height: 64px;
            bottom: -104px;
            left: 50%;
            -webkit-transform: translate3d(-50%, 0, 0);
            transform: translate3d(-50%, 0, 0);
        }
    }
    /deep/ .van-popup{
        overflow-y: initial;
        background: none;
    }
</style>